module.exports = __webpack_public_path__ + "img/AD.c4af67a5.svg";